export default __webpack_public_path__ + "static/media/account_circle_white.16774924.svg";